const login = {
    en: {
        "login.signIn": "Sign in",
        "login.welcome": "Welcome back — please enter your details.",
        "login.usernameEmail": "Username / Email",
        "login.usernamePlaceholder": "Enter username or email",
        "login.password": "Password",
        "login.passwordPlaceholder": "Enter password",
        "login.forgot": "Forgot password?",
        "login.logIn": "Log In",
        "login.orSearch": "or search a shipment",
        "login.privateCode": "Enter your private code",
        "login.heroTag": "Vehicle logistics & delivery management portal",
        "login.feature1": "Track vehicles from auction to delivery",
        "login.feature2": "Bookings, containers & transactions in one place",
        "login.feature3": "Secure, role-based access for your team",
        "login.rights": "All rights reserved.",
    },
    ru: {
        "login.signIn": "Вход",
        "login.welcome": "С возвращением — пожалуйста, введите свои данные.",
        "login.usernameEmail": "Имя пользователя / Эл. почта",
        "login.usernamePlaceholder": "Введите имя пользователя или эл. почту",
        "login.password": "Пароль",
        "login.passwordPlaceholder": "Введите пароль",
        "login.forgot": "Забыли пароль?",
        "login.logIn": "Войти",
        "login.orSearch": "или найдите отправление",
        "login.privateCode": "Введите ваш приватный код",
        "login.heroTag": "Портал управления логистикой и доставкой автомобилей",
        "login.feature1": "Отслеживайте автомобили от аукциона до доставки",
        "login.feature2": "Бронирования, контейнеры и транзакции в одном месте",
        "login.feature3": "Безопасный ролевой доступ для вашей команды",
        "login.rights": "Все права защищены.",
    },
    geo: {
        "login.signIn": "შესვლა",
        "login.welcome": "კეთილი იყოს თქვენი დაბრუნება — გთხოვთ, შეიყვანოთ თქვენი მონაცემები.",
        "login.usernameEmail": "მომხმარებელი / ელფოსტა",
        "login.usernamePlaceholder": "შეიყვანეთ მომხმარებელი ან ელფოსტა",
        "login.password": "პაროლი",
        "login.passwordPlaceholder": "შეიყვანეთ პაროლი",
        "login.forgot": "დაგავიწყდათ პაროლი?",
        "login.logIn": "შესვლა",
        "login.orSearch": "ან მოძებნეთ გზავნილი",
        "login.privateCode": "შეიყვანეთ თქვენი პირადი კოდი",
        "login.heroTag": "ავტომობილების ლოგისტიკისა და მიწოდების მართვის პორტალი",
        "login.feature1": "თვალყური ადევნეთ ავტომობილებს აუქციონიდან მიწოდებამდე",
        "login.feature2": "ჯავშნები, კონტეინერები და ტრანზაქციები ერთ ადგილას",
        "login.feature3": "უსაფრთხო, როლებზე დაფუძნებული წვდომა თქვენი გუნდისთვის",
        "login.rights": "ყველა უფლება დაცულია.",
    },
};

export default login;
